import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
export interface FileTypeConfig {
  id: string;
  name: string;
  description: string;
  extensions: string[];
  maxSizeMB: number;
  icon?: string;
}

export interface WorkproductFileConfig {
  workproductType: string;
  allowedFileTypes: FileTypeConfig[];
  maxFilesPerUpload: number;
  maxTotalSizeMB: number;
}

interface FileUploadModalProps {
  show: boolean;
  onHide: () => void;
  onFileUpload: (files: File[], fileType: string) => void;
  workproductType: string;
  fileConfig: WorkproductFileConfig;
  isLoading?: boolean;
  existingDocuments?: Array<{ docId: string; documentName: string }>;
}

const FileUploadModal: React.FC<FileUploadModalProps> = ({show,onHide,onFileUpload,fileConfig,isLoading=false}) => {
  const [files,setFiles]=useState<File[]>([]);
  const [error,setError]=useState("");
  useEffect(()=>{if(!show){setFiles([]);setError("");}},[show]);
  const config=fileConfig.allowedFileTypes[0];
  function select(list: FileList | null){
    const selected=Array.from(list || []);
    const invalid=selected.find(file=>!config.extensions.includes(file.name.split('.').pop()?.toLowerCase() || '') || file.size > config.maxSizeMB*1024*1024);
    if(invalid || selected.length > fileConfig.maxFilesPerUpload || selected.reduce((sum,file)=>sum+file.size,0)>fileConfig.maxTotalSizeMB*1024*1024){setFiles([]);setError(`Choose up to ${fileConfig.maxFilesPerUpload} PDF files, no larger than ${config.maxSizeMB} MB each and ${fileConfig.maxTotalSizeMB} MB combined.`);return;}
    setFiles(selected);setError("");
  }
  return <Modal show={show} onHide={()=>!isLoading && onHide()} centered>
    <Modal.Header closeButton={!isLoading}><Modal.Title>Upload reference documents</Modal.Title></Modal.Header>
    <Modal.Body>{error && <Alert variant="danger">{error}</Alert>}<Form.Label htmlFor="reference-files">PDF documents</Form.Label><Form.Control id="reference-files" type="file" multiple accept=".pdf" disabled={isLoading} onChange={e=>select((e.target as HTMLInputElement).files)} /><p className="text-secondary mt-2">Import an editable Word document using the editor’s document menu.</p>{files.map(file=><div key={file.name}>{file.name}</div>)}</Modal.Body>
    <Modal.Footer><Button variant="light" disabled={isLoading} onClick={onHide}>Cancel</Button><Button disabled={!files.length || isLoading} onClick={()=>onFileUpload(files,config.id)}>{isLoading?"Uploading…":"Upload"}</Button></Modal.Footer>
  </Modal>;
};
export default FileUploadModal;
